var $0ec14741b0133644$exports = {};
$0ec14741b0133644$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{418}\u{437}\u{431}\u{435}\u{440}\u{435}\u{442}\u{435} \u{43F}\u{440}\u{435}\u{434}\u{43C}\u{435}\u{442}`,
    "tableResizer": `\u{41F}\u{440}\u{435}\u{43E}\u{440}\u{430}\u{437}\u{43C}\u{435}\u{440}\u{438}\u{442}\u{435}\u{43B}`,
    "colorSwatchPicker": `Color swatches`
};


export {$0ec14741b0133644$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
